<template>
    <label :class="['input-field', {'is-textarea': isTextarea}]">

        <textarea style="resize: none"
                  v-if="isTextarea"
                  :value="value"
                  :placeholder="placeholder"
                  @input="$emit('input', $event.target.value)"
        >
        </textarea>

        <input v-else
               :value="value"
               :type="type"
               :placeholder="placeholder"
               @input="$emit('input', $event.target.value)"
        >

    </label>
</template>

<script>
    export default {
        name: "Input",
        props: {
            value: {
                type: [String, Number],
                default: ''
            },
            type: {
                type: String,
                default: 'text'
            },
            placeholder: {
                type: String,
                default: ''
            },
            isTextarea: {
                type: Boolean,
                default: false
            }
        }
    }
</script>